import axios from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { SummaryOrderResponse } from "types/order-summary";

export interface UseOrderSummaryParams {
    shipping_date?: string;
}

const useOrderSummary = (params: UseOrderSummaryParams) => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();

    const queryParams = new URLSearchParams(params as unknown as Record<string, string>).toString();

    return useQuery<unknown, unknown, SummaryOrderResponse>({
        queryKey: ['get-summary-orders', queryParams],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/queue/order/summary?${queryParams}`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useOrderSummary;